<div class="mat-card settings-card">
    <div class="card-innner-con">
        <div class="settings-card-title">
            <span>{{title}}</span>
            <span class="material-icons" [matTooltip]="tooltip"
            matTooltipClass="asp-custom-tooltip">help_outline </span>
        </div>
        <div class="settings-card-body">
            <div class="field-container">
                <div class="filed-title">
                    <span>{{label}}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch">
                    <app-onofswitch [switchInput]='value'
                    (switchChange)="updateSwitchValues($event)"></app-onofswitch>
                    <div class="readonly-layer" *ngIf="label === ('generalSettings.enableCustomerNotifications' | translate) "></div>
                </div>
            </div>
        </div>
    </div>
</div>